<template>
    <transition :name="container.transitionName">
        <component
            :is="is"
            v-show="active"
        >
            <slot />
        </component>
    </transition>
</template>

<script>
import { container } from '@/js/util/carousel';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'CarouselItem',
    defaultTag: 'div',
    mixins: [dynamicComponent],
    inject: { container },
    computed: {
        active() {
            this.$emit('changedSlide');
            return this === this.container.activeItem;
        },
    },
    created() {
        this.container.$emit('createdItem', this);
    },
    beforeDestroy() {
        this.container.$emit('beforeDestroyItem', this);
    },
};
</script>



// WEBPACK FOOTER //
// src/components/carousel/CarouselItem.vue